import React, { useState } from 'react';
import { PaginationControls } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

type Props = {
  onPageChangeHandler: (selectedItem: { selected: number }) => void;
  pageCount: number;
};

export function Pagination(props: Props) {
  const [selectedPage, setSelectedPage] = useState(1);

  function handleIncrement() {
    const selected = selectedPage + 1;
    setSelectedPage(selected);
    props.onPageChangeHandler({ selected });
  }

  const allowIncrement = selectedPage + 1 <= props.pageCount;
  const onIncrement = allowIncrement ? handleIncrement : undefined;

  function handleDecrement() {
    const previousPage = selectedPage - 1;
    setSelectedPage(previousPage);
    props.onPageChangeHandler({ selected: previousPage });
  }

  const allowDecrement = selectedPage - 1 > 0;
  const onDecrement = allowDecrement ? handleDecrement : undefined;

  return (
    <PaginationContainer>
      <PaginationControls onIncrement={onIncrement} onDecrement={onDecrement}>
        <FormattedMessage
          id="pagination"
          defaultMessage="{selectedPage, number} of {pageCount, number}"
          values={{
            selectedPage,
            pageCount: props.pageCount,
          }}
        />
      </PaginationControls>
    </PaginationContainer>
  );
}

const PaginationContainer = styled.div`
  margin: 16px 0px;
`;
